module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "surveillance-symptoms"
  }, [_c('div', {
    staticClass: "clearfix",
    slot: "header"
  }, [_c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('span', [_vm._v("Infection Site/Type: ")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 14
    }
  }, [_vm._v(_vm._s(_vm.caseData.symptomType) + " - \n        "), _c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": _vm.symptomDetail(_vm.caseData.symptomType),
      "placement": "bottom"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("View Details")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('span', [_vm._v("Symptoms Exhibited: ")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 16
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "border": "",
      "data": _vm.caseData.symptoms,
      "default-sort": {
        prop: 'created',
        order: 'descending'
      }
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "On Set Date",
      "width": "120"
    },
    scopedSlots: {
      default: function(scope) {
        return [_vm._v("\n                    " + _vm._s(_vm._f("moment")(scope.row.onSetDate, 'DD-MM-YYYY')) + "\n                  ")]
      }
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Symptom"
    },
    scopedSlots: {
      default: function(scope) {
        return [_c('div', {
          staticClass: "case-note-content"
        }, [_vm._v(_vm._s(scope.row.displayText))])]
      }
    }
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-47677520!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/components/SurveillanceSymptoms.vue
// module id = 245
// module chunks = 2